import { NiUtils } from "src/app/mockup/utils/ni";
import { TipoNI } from "src/app/sitfis/model/enum/tipo-ni";
import { ModalidadeArrecadacaoDto } from "./modalidade-arrecadacao-dto";
import { NaturezaDto } from "./natureza-dto";
import { OrigemErroDto } from "./origem-erro-dto";
import { PagamentoDto } from "./pagamento-dto";
import { PessoaFisicaDto } from "./pessoa-fisica-dto";
import { PessoaJuridicaDto } from "./pessoa-juridica-dto";
import { ReceitaDto } from "./receita-dto";
import { SistemaInteresseDto } from "./sistema-interesse-dto";
import { SituacaoDocumentoDto } from "./situacao-documento-dto";
import { TipoDocumentoDto } from "./tipo-documento-dto";
import { TipoNIRDOC } from "./tipo-ni-rdoc";

export class Pagamento implements PagamentoDto {
  public pgtoNr: string;
  public pgtoDtArrecadacao: Date;
  public pgtoDtRegistro: Date;
  public pgtoInTp: string;
  public situacao: SituacaoDocumentoDto;
  public pgtoSituCd: number;
  public pgtoBVlCompensacao: number;
  public pgtoBVlAlocadoRl: number;
  public pgtoInContribNIdent: string;
  public pgtoInUtilCobranca: string;
  public pgtoVlTotal: number;
  public pgtoBVl1: number;
  public pgtoInImpedeAloc: string;
  public pgtoInOrigem: string;
  public pgtoAgenAgtaCd: number;
  public pgtoAgenCd: number;
  public codigoBancoCPS: string;
  public codigoAgenciaCPS: string;
  public pgtoInDesmembrado: string;
  public pgtoBVlRlocal: number;
  public pgtoBVlGporte: number;
  public valorCancelado: number;
  public pgtoBInInteresse: string;
  public pgtoBInPassivo: string;
  public pgtoBInAtualizacao: string;
  public pgtoBDtAtualizacao: Date;
  public pgtoBInHistorico: string;
  public pgtoUa: string;
  public pgtoEstbPjNr: number;
  public pgtoEstbNr: number;
  public pgtoOepgCd: number;
  public origemErro: OrigemErroDto;
  public pgtoDtVencimento: Date;
  public pgtoNrPeriodoApur: number;
  public pgtoNrProcesso: string;
  public pgtoNrReferencia: string;
  public pgtoProcNr: string;
  public pgtoNrParcela: number;
  public pgtoReleNrSq: number;
  public pgtoPfNr: number;
  public pgtoBNrBdaSq: number;
  public pgtoRpapNrBda: number;
  public pgtoBDtRecepcao: Date;
  public pgtoAlspCd: number;
  public pgtoDtEncerraPerApu: Date;
  public pgtoMndpCd: number;
  public pgtoBVl2: number;
  public pgtoBVl3: number;
  public pgtoBVl4: number;
  public pgtoBVl5: number;
  public pgtoBUaCdAtualiza: number;
  public pgtoBIpTerminal: string;
  public pgtoBNrTerminal: string;
  public pgtoBPfNrAtualiza: number;
  public pgtoBVlRestituicao: number;
  public pgtoNrContribNident: string;
  public pgtoInAutorizaDebCc: string;
  public pgtoInMeioColeta: string;
  public pgtoNrProtocolDebCc: number;
  public pgtoNrIdDepositoCef: number;
  public pgtoBVlSaldoPrincipal: number;
  public pgtoBVlSaldoMulta: number;
  public pgtoBVlSaldoJuros: number;
  public pgtoBInDelecaoLogica: string;
  public pgtoBInRecInval: string;
  public pgtoNrDvContrib: number;
  public pgtoBDtRegistroGporte: Date;
  public pgtoNrIdAr: string;
  public pgtoDtLimitePgtoDeb: Date;
  public pgtoDtRecepRegEmAg: Date;
  public pgtoInMeioRecepInf: number;
  public pgtoNrCtrlRecepInf: string;
  public pgtoInCondSitReg: number;
  public pgtoUaDtPgto: number;
  public pgtoUaClassCd: number;
  public pgtoDtGerRegSistOrig: Date;
  public pgtoInOrigemAr: number;
  public pgtoBVlDjeSunl: number;
  public pgtoBVlDjeSdnl: number;
  public pgtoBVlDjeSutd: number;
  public pgtoBVlDjeSdtd: number;
  public pgtoBVlDjeVtdc: number;
  public pgtoPgtoNrIdAr: string;
  public pgtoNitNi: number;
  public pgtoNrInscrDau: number;
  public pgtoNrCno: number;
  public pgtoNrNit: number;
  public pgtoNrNirf: number;
  public pgtoCnpjPrestador: number;
  public pgtoCpfSegurado: number;
  public pgtoEdbaNrSq: number;
  public pgtoTqrpCd: number;
  public pgtoMcanCd: number;
  public modalidadeArrecadacao: ModalidadeArrecadacaoDto;
  public pgtoPcRecBrut: number;
  public pgtoVlRecBrutAcum: number;
  public pgtoSearTmarCd: number;
  public pgtoSearTprCd: number;
  public pgtoSearTspCd: number;
  public pgtoSearTaudCd: number;
  public pgtoTifpCd: number;
  public receita01: ReceitaDto;
  public pgtoBRecCd1: number;
  public receita02: ReceitaDto;
  public pgtoBRecCd2: number;
  public receita03: ReceitaDto;
  public pgtoBRecCd3: number;
  public receita04: ReceitaDto;
  public pgtoBRecCd4: number;
  public receita05: ReceitaDto;
  public pgtoBRecCd5: number;
  public pgtoBRecDt1: Date;
  public pgtoBRecDt2: Date;
  public pgtoBRecDt3: Date;
  public pgtoBRecDt4: Date;
  public pgtoBRecDt5: Date;
  public pgtoBOepgDt: Date;
  public pgtoBSituDt: Date;
  public pgtoBAgenDt: Date;
  public pgtoBMcanDt: Date;
  public pgtoBMndpDt: Date;
  public pgtoBAlspDt: Date;
  public tipoDocumento: TipoDocumentoDto;
  public pgtoSearTdaCd: number;
  public natureza: NaturezaDto;
  public pgtoTnrCd: number;
  public sistemaGerador: SistemaInteresseDto;
  public pgtoTsgiCd: number;
  public sistemaInteresse: SistemaInteresseDto;
  public pgtoTpsiCd: number;
  public pgtoMunicClassCd: number;
  public pgtoBCdMunDomContrib: number;
  public pgtoDovrNrSq: number;
  public alterouPABase2: boolean;
  public alterouCodigoReceitaBase2: boolean;
  public getnSaldoDisponivel: number[];
  public getnValorDevolvido: number;
  public getnValorTransformado: number;
  public darcNrAutenticPgto: string;
  public codigoBarras: string;
  public pessoaFisicaDto: PessoaFisicaDto;
  public pessoaJuridicaDto: PessoaJuridicaDto;
  public agendadoPara: string;
  public nrTransformacaoNo: string;
  public mensagemVinculacao: string;
  public pgtoInDara: string;
  public documentoNumerado: boolean;
  public canceladoTransformacao: boolean;
  public vinculado: boolean;
  public agendado: boolean;
  public canceladoParcial: boolean;
  public cancelado: boolean;
  public pago: boolean;
  public darfNumerado: boolean;
  public dje: boolean;
  public das: boolean;

  public ni: string;
  public tipoNiRdoc: TipoNIRDOC;

  public niContribuinte: string;
  public tipoNiContribuinte: TipoNIRDOC;
  public nomeContribuinte: string;
  public valoresDocumento: ValorDocumento[];

  public numeroProcessoRetificacao: string;

  public get tipoNi(): TipoNI {
    if (this.tipoNiRdoc == null || this.ni == null || this.ni.length === 0) {
      throw new Error("O NI não foi calculado corretamente.");
    }

    switch (this.tipoNiRdoc) {
      case TipoNIRDOC.CPF:
        return TipoNI.CPF;

      case TipoNIRDOC.CNPJ:
        return TipoNI.CNPJ;

      case TipoNIRDOC.NI_INVALIDO:
        return this.ni.length > 11 ? TipoNI.CNPJ : TipoNI.CPF;

      default:
        throw new Error(`Tipo de NI desconhecido: ${this.tipoNiRdoc}`);
    }
  }

  // TODO VIA-3571522: Descobrir o que caracteriza um pagamento com multa ou juros
  public get possuiMultaJuros(): boolean {
    return this.receita02?.descricao?.includes("Multa") || this.receita03?.descricao?.includes("Juros") || this.darcNrAutenticPgto != null;
  }

  constructor(pagamentoDto?: PagamentoDto) {
    if (pagamentoDto == null) {
      return;
    }

    Object.assign(this, pagamentoDto);

    this.converterCamposDatas();

    this.calcularNi();
    this.calcularDadosContribuinte();
    this.calcularValoresDocumento();
  }

  private converterCamposDatas(): void {
    const camposDatas = [
      'pgtoDtArrecadacao',
      'pgtoDtRegistro',
      'pgtoBDtRecepcao',
      'pgtoDtVencimento',
      'pgtoDtEncerraPerApu',
      'pgtoBRecDt1',
      'pgtoBRecDt2',
      'pgtoBRecDt3',
      'pgtoBRecDt4',
      'pgtoBRecDt5',
      'pgtoBOepgDt',
      'pgtoBSituDt',
      'pgtoBAgenDt',
      'pgtoBMcanDt',
      'pgtoBMndpDt',
      'pgtoBAlspDt',
      'pgtoDtRecepRegEmAg',
      'pgtoDtLimitePgtoDeb',
      'pgtoDtGerRegSistOrig',
      'pgtoBDtRegistroGporte',
    ];

    for (const campo of camposDatas) {
      if (this[campo]) {
        let data = this[campo];

        // O trecho {T12:00:00.000Z} garante que a data seja convertida corretamente sem a margem de erro de 1 dia
        const horario = "T12:00:00.000Z";

        if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}$/) != null) {
          data += horario;
        }

        if (typeof data === 'number') {
          data = data.toString().replace(/(\d{4})(\d{2})(\d{2})/, `$1-$2-$3${horario}`);
        }

        this[campo] = new Date(data);
      }
    }
  }

  private calcularNi(): void {
    // 760981 RN - Pagamento - Dados de Pagamentos
    // RN 1.1-08 - Formatação do NI do Pagamento
    if (this.pgtoNrContribNident != null && this.pgtoNrContribNident.length > 0) {
      this.ni = this.pgtoNrContribNident;
      this.tipoNiRdoc = TipoNIRDOC.NI_INVALIDO;
    }
    else if (this.pgtoPfNr != null) {
      this.ni = NiUtils.obterNiCompleto(this.pgtoPfNr, "cpf");
      this.tipoNiRdoc = TipoNIRDOC.CPF;
    }
    else if (this.pgtoEstbPjNr != null) {
      this.ni = this.pgtoEstbPjNr.toString();
      this.ni += this.pgtoEstbNr.toString().padStart(4, '0');
      this.ni = NiUtils.obterNiCompleto(this.ni, "cnpj");
      this.tipoNiRdoc = TipoNIRDOC.CNPJ;
    }
  }

  private calcularDadosContribuinte() {
    // 817657 RN - Pagamento - Dados do Pagamento
    // RN 1.3.1-10 - Recuperação dos Dados do Contribuinte
    if (this.pessoaFisicaDto != null) {
      this.nomeContribuinte = this.pessoaFisicaDto.nome;
      this.niContribuinte = this.pessoaFisicaDto.codigo.toString();
      this.tipoNiContribuinte = TipoNIRDOC.CPF;
    }
    else if (this.pessoaJuridicaDto != null) {
      this.nomeContribuinte = this.pessoaJuridicaDto.nome;
      this.niContribuinte = this.pessoaJuridicaDto.codigo.toString();
      this.tipoNiContribuinte = TipoNIRDOC.CNPJ;
    }
  }

  private calcularValoresDocumento() {
    const chaves = Object.values(TipoValorEnum).filter(v => typeof v === "number") as TipoValorEnum[]
    this.valoresDocumento = chaves.map((chave) => { return { tipo: chave } as ValorDocumento; });

    if (this.possuiMultaJuros) {
      this.valoresDocumento[TipoValorEnum.MULTA].valor = 0;
      this.valoresDocumento[TipoValorEnum.JUROS].valor = 0;
    }

    if (this.receita01 != null) {
      this.valoresDocumento[TipoValorEnum.PRINCIPAL].receita = this.receita01;
      this.valoresDocumento[TipoValorEnum.PRINCIPAL].valor = this.pgtoBVl1;
    }
    if (this.receita02 != null) {
      this.valoresDocumento[TipoValorEnum.MULTA].receita = this.receita02;
      this.valoresDocumento[TipoValorEnum.MULTA].valor = this.pgtoBVl2;
    }
    if (this.receita03 != null) {
      this.valoresDocumento[TipoValorEnum.JUROS].receita = this.receita03;
      this.valoresDocumento[TipoValorEnum.JUROS].valor = this.pgtoBVl3;
    }
    // if (this.receita04 != null) { }
    // if (this.receita05 != null) { }

    const valorTotal = this.valoresDocumento.reduce((total, valorDocumento) => total + (valorDocumento.valor ?? 0), 0);

    this.valoresDocumento[TipoValorEnum.TOTAL].valor = valorTotal;
    this.valoresDocumento[TipoValorEnum.TOTAL].saldo = 0;
  }
}

export interface ValorDocumento {
  tipo: TipoValorEnum;
  receita?: ReceitaDto;
  valor?: number;
  saldo?: number;
  mensagem?: string;
}

// A ordem neste enum é importante para a exibição correta dos valores no frontend
export enum TipoValorEnum {
  PRINCIPAL,
  MULTA,
  JUROS,
  TOTAL,
}

export const TipoValorLabels: { [key in TipoValorEnum]: string } = {
  [TipoValorEnum.PRINCIPAL]: "Principal",
  [TipoValorEnum.MULTA]: "Multa",
  [TipoValorEnum.JUROS]: "Juros",
  [TipoValorEnum.TOTAL]: "Valor Total"
};

export enum AtributoPagamento {
  ni = "ni",
  tipoNiRdoc = "tipoNiRdoc",
  periodoApuracao = "pgtoDtEncerraPerApu",
  dataVencimento = "pgtoDtVencimento",
  dataRecepcao = "pgtoBDtRecepcao",
  processo = "processo",
  referenciaNr = "pgtoNrReferencia",
  idDepositoCef = "pgtoNrIdDepositoCef",
  vrba = "pgtoVlRecBrutAcum",
  vrbaPerc = "pgtoPcRecBrut",
  bancoCd = "pgtoAgenAgtaCd",
  agenciaCd = "pgtoAgenCd",
  dataArrecadacao = "pgtoDtArrecadacao",
  origemErro = "origemErro",
  processoRetificacaoNr = "numeroProcessoRetificacao",
  numeroDocumento = "numeroDocumento",
  valoresReceita = "valoresReceita",
}